<template>
    <div class="flex flex-col overflow-y-auto max-h-screen-1/2">
        <nio-dropdown-item
            :disabled="isDisabled"
            :selected="selectedAccount.id == account.id"
            :key="account.id"
            @click="onAccountSelect(account.id)"
            v-for="account in accounts"
        >
            {{ account.name }}
        </nio-dropdown-item>
    </div>
</template>

<script>
    import orderBy from 'lodash/orderBy';
    import { mapState, mapActions } from 'vuex';

    export default {
        computed: {
            ...mapState([
                'authUser',
            ]),

            selectedAccount() {
                return this.authUser.accounts.find(account => {
                    return account.id == this.authUser.account.id;
                });
            },

            accounts() {
                const accounts = this.authUser.accounts.map(account => {
                    return {
                        id: account.id,
                        name: account.name,
                    };
                });

                return orderBy(accounts, 'name');
            },

            isDisabled() {
                return typeof this.$route.meta.mayChangeAccount !== 'undefined' &&
                    !this.$route.meta.mayChangeAccount;
            },
        },

        methods: {
            ...mapActions([
                'setAuthUserAccount',
                'fetchTemplatePlaceholders',
            ]),

            onAccountSelect(accountId) {
                if (this.authUser.account.id == accountId) {
                    return;
                }

                const account = this.authUser.accounts.find(a => a.id == accountId);

                this.setAuthUserAccount(account);
                this.fetchTemplatePlaceholders();
            },
        },
    };
</script>
